var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isNotFound)?_c('NotFound'):(_vm.isForbidden)?_c('Forbidden'):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }